import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { convertPetRewardListToStrings, useMixins } from '@/modules/picword/pet/model/mixins';
import { ROUTE_NAME_PICWORD } from '@/modules/picword/router';
import { picwordService } from '@/services/picword';

export function usePicwordPetAdd() {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { v$, rewardV$, model, SelectableBooster } = useMixins();

    const actions = {
        create: crudAction.excuteAndNotify({
            validator: v$,
            request: () => {
                const reward = convertPetRewardListToStrings(model.rewardList);
                return picwordService.pet.create(
                    model.id,
                    model.interactiveSeconds,
                    model.gachaWeights,
                    model.totalLevel,
                    reward.experienceByLevels,
                    reward.creditRewards,
                    reward.heartRewards,
                    reward.boosterRewards
                );
            },
            onSuccess: () => router.push({ name: ROUTE_NAME_PICWORD.PET.INDEX })
        })
    };

    return { model, v$, rewardV$, fetch, actions, SelectableBooster };
}
